import _ from 'lodash'
import qs from 'qs'
import { toggleLogAs, setToken } from 'ducks/app'

const preprocessor = store => next => action => {
  if (!!window.location.search) {
    const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })

    if (action.type === '@@router/LOCATION_CHANGE') {
      const keys = [
        'pricelist_id',
        'utm_source',
        'utm_campaign',
        'utm_content',
        'utm_term',
        'utm_medium'
      ]
      const newRef = _.pick(queryParams, keys)
      const oldRef = JSON.parse(window.localStorage.getItem('app.ref'))

      window.localStorage.setItem('app.ref', JSON.stringify({...oldRef, ...newRef}))
  
      if (!!queryParams.token){
        store.dispatch(toggleLogAs(true))
        store.dispatch(setToken(queryParams.token))
      }
    }
  }

  return next(action)
}

export default preprocessor


// WEBPACK FOOTER //
// ./src/ducks/preprocessor.js